import { DistributionConfigPage } from '@/pages/crm/chain/DistributionConfigPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/crm/chain/distribution')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainDistribution.configure'], redirectTo: '/dashboard' }),
	component: DistributionConfigPage,
});
